/**
 * Internal dependencies
 */
import { usePlayerState } from 'context';

const useCurrentEpisode = () => usePlayerState()[0].currentEpisode;

export default useCurrentEpisode;
